const Constants = {
  TONNE: 20090001,
  KILOGRAM: 20090002,
  UNITY: 20090007,
  TRIP: 20090011,
  BUCKET: 2009012,
  FINAL_DESTINATION: 20040001,
  WASTE_COLLECTION: 20040002,
  VALORIZATION: 20040003,
  ETE: 20040004,
  AUTOCLAVE: 20040005,
  RCC: 20040006,
  SHIPPING: 20040007,
  CONTRACT_MAINTENANCE: 20040008,
  RECEIPT_VALORIZATION: 20040009,
  WEIGHING_SERVICE: 20040010,
  TWM_SERVICE: 20040011,
  HORIZONTAL_BALING_PRESS: 20040012,
  WEIGHING_AND_TRACEABILITY_PROJECT: 20040013,
  EFFLUENT_WATER_TREATMENT: 20040014,
  FREIGHT_APPORTIONMENT: 20040015
}

export default Constants
